<template>
  <div class="about">
    <v-row justify="center">
      <v-col align="center" class="i-blue fixed z4">
        <h3 class="i-powderblue--text">About Us</h3>
      </v-col>
    </v-row>

    <br/>
    <br/>

    <v-row justify="center">
      <v-col cols=12 align="center">
        <transition name="slideYneg">
          <v-card v-if="$keys[0]" elevation=3 class="col-lg-11 col-11 mt-10 i-powderblue">
            <v-card-title class="i-blue--text">
              <h3 class="center">Overview</h3>
            </v-card-title>

            <v-row justify="center">
              <v-col class="col-lg-3 col-4">
                <v-img :src="require('../assets/images/hire_vehicles.jpeg')" :height="imgHeight" title="vehicles" alt="vehicles" cover />
              </v-col>
              <v-col class="col-lg-3 col-4">
                <v-img :src="require('../assets/images/hire_property1.jpg')" :height="imgHeight" title="properties" alt="properties" cover />
              </v-col>
              <v-col class="col-lg-3 col-4">
                <v-img :src="require('../assets/images/hire_equipment2.jpg')" :height="imgHeight" title="equipment" alt="equipment" cover />
              </v-col>
            </v-row>

            <v-card-text align="left" class="col-lg-10">
              <p class="i-deepblue--text">
                <b>Instarent hub</b> 
                is an e-commerce platform where 
                <a @click="userPath('client')">clients</a> meet <a @click="userPath('leaser')">leasers</a> for short and medium term rental contracts. 
                Our services are tailored to accommodate all kinds of rentals for vehicles, property and equipment. <br/>
                Are you a leaser looking for clients, or a client searching for items to hire? 
                All you have to do is answer a few questions and we will find what you need.
              </p>

              <v-scale-transition>
                <p v-if="leaser" id="leaser">
                  <b>Leaser:</b> <br/>
                  A leaser is someone in posession of a property with legal authority to grant access to the property 
                  in agreement with our terms and conditions.
                </p>
              </v-scale-transition>

              <v-scale-transition>
                <p v-if="client" id="client">
                  <b>Client:</b> <br/>
                  A client is someone who is searching for vehicles, property or equipment for hire in agreement with 
                  our terms and conditioins.
                </p>
              </v-scale-transition>
            </v-card-text>
          </v-card>
        </transition>
      </v-col>

      <v-col align="center" class="col-lg-5 col-11 mt-10 mr-lg-7">
        <transition name="slideYneg">
          <v-card v-if="$keys[1]" elevation=3 class="col-12 i-lightrose">
            <v-card-title class="i-powderblue--text">
              Advertise
            </v-card-title>

            <v-row>
              <v-col>
                <v-img :src="require('../assets/images/advertise1.jpeg')" height=200 />
              </v-col>
            </v-row>

            <v-card-text align="left">
              <p class="i-powderblue--text">Post adverts of your vehicles, property and equipment for hire on our platform. 
                We help you get connected to the right customers by showcasing your items to a large number of clients who need to 
                hire your property.
              </p>
            </v-card-text>
            <br/>

            <v-row>
              <v-btn
                rounded
                elevation=6
                outlined
                link
                to="advertise"
                class="i-darkblue i-powderblue--text center">
                Advertise Now
              </v-btn>
            </v-row>
          </v-card>
        </transition>
      </v-col>

      <v-col align="center" class="col-lg-5 col-11 mt-10 ml-lg-7">
        <transition name="slideYneg">
          <v-card v-if="$keys[1]" elevation=3 class="col-12 i-darkblue">
            <v-card-title class="i-powderblue--text">
              Hire
            </v-card-title>

            <v-card-text align="left">
              <p class="i-powderblue--text">
                Are you looking for a vehicle, property or equipment for hire? 
                Our platform helps connect you to a host of leasers with good rental deals that suit your budget.
              </p>

              <p class="i-powderblue--text">We also reward customers who refer new customers to our
                platform.
              </p>
            </v-card-text>

            <v-row>
              <v-col>
                <v-img :src="require('../assets/images/hire.jpeg')" height=200 />
              </v-col>
            </v-row>

            <v-row>
              <v-btn
                rounded
                elevation=6
                outlined
                link
                to="hire"
                class="pr-10 pl-10 i-powderblue--text i-lightrose center">
                Get Started
              </v-btn>
            </v-row>
          </v-card>
        </transition>
      </v-col>

      <v-col cols=12 align="center">
        <transition name="slideYneg">
          <v-card v-if="$keys[3]" elevation=3 class="col-lg-11 col-11 mt-10 i-powderblue">
            <v-card-title>
              <h3 class="i-blue--text center">Our Mission</h3>
            </v-card-title>

            <v-card-text align="left">
              <p class="i-deepblue--text">
                At Instarent hub, we're passionate about helping you find the best solutions for your rental needs.
                Here are some of the goals that direct our daily efforts;
              </p>
              <ol>
                <li>
                  <p>
                    We aim to take away the hassle involved with rental contracts for both leasers and clients,
                    by offering the most secure rental services, protecting the interests of both parties.
                  </p>
                </li>
                <li>
                  <p>
                    We aim to manage a collection of the best rental deals available at all times, giving you the luxury of choice.
                  </p>
                </li>
                <li>
                  <p>
                    We pursue excellent service delivery by using only the best technical solutions and partnering with key industry players.
                  </p>
                </li>
                <li>
                  <p>
                    We strive to maintain a high operational standard which involves putting your interests before anything else.
                  </p>
                </li>
              </ol>
            </v-card-text>
          </v-card>
        </transition>
      </v-col>

      <v-col cols=12 align="center">
        <transition name="slideYneg">
          <v-card v-if="$keys[4]" elevation=3 class="col-lg-11 col-11 mt-10 i-powderblue">
            <v-card-title>
              <h3 class="i-blue--text center">Track Record</h3>
            </v-card-title>

            <v-card-text>
              <v-row justify="center">
                <v-col class="col-lg-10 col-12">
                  <p>We are proud to display the progress we are making in real time, as a result of your patronage.</p>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col align="left" class="col-lg-4 col-11 mr-lg-10 mt-lg-0 mt-12 i-cream">
                  <h3 class="i-deepblue--text badscript">Total adverts: <span>0</span></h3>
                  <br/>
                  <h3 class="i-deepblue--text badscript">Total vehicles: <span>0</span></h3>
                  <br/>
                  <h3 class="i-deepblue--text badscript">Total properties: <span>0</span></h3>
                  <br/>
                  <h3 class="i-deepblue--text badscript">Total equipment: <span>0</span></h3>
                </v-col>

                <v-col align="left" class="col-lg-4 col-11 ml-lg-10 mt-lg-0 mt-12 i-rose">
                  <h3 class="i-powderblue--text badscript">Total rental deals: <span>0</span></h3>
                  <br/>
                  <h3 class="i-powderblue--text badscript">Active rental deals: <span>0</span></h3>
                  <br/>
                  <h3 class="i-powderblue--text badscript">Total customers: <span>0</span></h3>
                  <br/>
                  <h3 class="i-powderblue--text badscript">Total partners: <span>0</span></h3>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </transition>
      </v-col>

      <v-col cols=12 align="center">
        <transition name="slideYneg">
          <v-card v-if="$keys[5]" align="center" elevation=3 class="col-lg-11 col-11 mt-10 i-powderblue">
            <v-card-title>
              <h3 class="i-blue--text center">Our Team</h3>
            </v-card-title>

            <v-card elevation=5 class="col-lg-11 mb-12 pt-0 pb-0 curved no-overflow">
              <v-row>
                <v-col id="imageContainer" align="center" class="col-lg-3 col-12 i-cream pr-0 pl-0 pt-0 pb-0">
                  <v-img  :src="require('../assets/images/hire.jpeg')" :height="getParentHeight('imageContainer')" />
                </v-col>

                <v-col align="left" class="col-lg-9 col-12 i-darkblue">
                  <v-card-title class="i-blue--text">
                    {team member name}
                  </v-card-title>

                  <v-card-subtitle class="i-cream--text">
                    {team member designation}
                  </v-card-subtitle>
                  <v-card-text>
                    <p class="i-powderblue--text">
                      A brief introduction and their contribution to the project
                    </p>

                    <v-btn class="mr-5"
                      color="transparent">
                      <v-icon class="i-blue--text">mdi-facebook</v-icon>
                    </v-btn>

                    <v-btn class="mr-5"
                      color="transparent">
                      <v-icon class="i-lightrose--text">mdi-instagram</v-icon>
                    </v-btn>

                    <v-btn
                      color="transparent">
                      <v-icon class="cyan--text">mdi-twitter</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>

            <v-card elevation=5 class="col-lg-11 mb-12 pt-0 pb-0 curved no-overflow">
              <v-row>
                <v-col id="imageContainer" align="center" class="col-lg-3 col-12 i-cream pr-0 pl-0 pt-0 pb-0">
                  <v-img  :src="require('../assets/images/hire.jpeg')" :height="getParentHeight('imageContainer')" />
                </v-col>

                <v-col align="left" class="col-lg-9 col-12 i-darkblue">
                  <v-card-title class="i-blue--text">
                    {team member name}
                  </v-card-title>

                  <v-card-subtitle class="i-cream--text">
                    {team member designation}
                  </v-card-subtitle>
                  <v-card-text>
                    <p class="i-powderblue--text">
                      A brief introduction and their contribution to the project
                    </p>

                    <v-btn class="mr-5"
                      color="transparent">
                      <v-icon class="i-blue--text">mdi-facebook</v-icon>
                    </v-btn>

                    <v-btn class="mr-5"
                      color="transparent">
                      <v-icon class="i-lightrose--text">mdi-instagram</v-icon>
                    </v-btn>

                    <v-btn
                      color="transparent">
                      <v-icon class="cyan--text">mdi-twitter</v-icon>
                    </v-btn>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-card>
        </transition>
      </v-col>
    </v-row>

    <br/>
    <br/>
  </div>
</template>

<script>
export default {
  name: 'About',

  data: () => ({
    leaser: false,
    client: false
  }),

  computed: {
    mobile () {
      let value
      window.innerWidth <= 760
      ? value = true
      : value = false

      return value
    },

    imgHeight () {
      let value
      
      this.mobile
      ? value = 100
      : value = 200

      return value
    }
  },

  methods: {
    userPath (token) {
      if (token === 'leaser') {
        this.client = false
        this.leaser = true
      } else if (token === 'client') {
        this.leaser = false
        this.client = true
      }
    },

    getParentHeight(id) {
      if (!this.mobile) {
        let element = document.getElementById(id)

        if (element !== null && typeof(element) === 'object') {
          return this.getComputedStyles(element, 'height')
        }
      }
    }
  },

  mounted() {
    
  },

  hasAnim: true
}
</script>
